import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircleSlash, RefreshCw } from "lucide-react";
import { useToastContext } from "../../context/ToastContext";
import { useSettingsContext } from "../../context/SettingsContext";

const StripeError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get("message") || "An unknown error occurred.";
  const { showToast } = useToastContext();
  const { setIsSettingsOpen, setActiveSettingsTab } = useSettingsContext();
  const navigate = useNavigate();
  const [isRetrying, setIsRetrying] = useState(false);

  useEffect(() => {
    showToast("error", message);
  }, [message, showToast]);

  const handleRetry = () => {
    setIsRetrying(true);
    setTimeout(() => {
      setActiveSettingsTab("integrations");
      setIsSettingsOpen(true);
      navigate("/");
    }, 1500);
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-background-default dark:bg-background-dark px-6">
      <div className="flex flex-col items-center text-text-primary dark:text-text-primaryDark">
        <CircleSlash className="w-16 h-16 text-red-500 mb-6 stroke-[1]" />
        <h2 className="text-2xl font-semibold">Stripe Connection Failed</h2>
        <p className="text-sm text-text-secondary dark:text-text-secondaryDark mt-4">
          {message}
        </p>
        <button
          onClick={handleRetry}
          className="mt-6 px-6 py-3 border-2 border-red-500 text-red-500 rounded-lg font-bold text-sm hover:bg-red-500 hover:text-white transition flex items-center justify-center"
          disabled={isRetrying}
        >
          <RefreshCw
            className={`w-5 h-5 mr-2 ${isRetrying ? "animate-spin" : ""}`}
          />
          {isRetrying ? "Retrying..." : "Retry Stripe Connection"}
        </button>
      </div>
    </div>
  );
};

export default StripeError;

